// LLM generated - Model Claude 4 Sonnet
import { Title } from '~/domains/design-system/Title';
import type { titleStyles } from '~/domains/design-system/Title';
import dt from '~/testing';

type HeaderTitleProps = {
  title: string;
  variant?: keyof typeof titleStyles;
  className?: string;
};

export function HeaderTitle({
  title,
  variant = 'display-headline-expanded-xl',
  className,
}: HeaderTitleProps) {
  return (
    <Title variant={variant} c="gray2.6" className={className}>
      {title}
    </Title>
  );
}
